import { render } from "./RecentProductsGrid.vue?vue&type=template&id=49d2218b&scoped=true"
import script from "./RecentProductsGrid.vue?vue&type=script&lang=js"
export * from "./RecentProductsGrid.vue?vue&type=script&lang=js"

import "./RecentProductsGrid.vue?vue&type=style&index=0&id=49d2218b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49d2218b"]])

export default __exports__